import type { ReactNode } from 'react'
import React from 'react'

import type { BannerProps } from '@fourthwall/components'
import { Banner } from '@fourthwall/components'

import * as S from './ErrorBanner.styled'

export type ErrorBannerProps = {
  enabled?: boolean
  appearance?: BannerProps['appearance']
  children: ReactNode
}

export const ErrorBanner = ({
  enabled = true,
  appearance = 'danger',
  children,
}: ErrorBannerProps) => {
  if (!enabled) {
    return null
  }

  return (
    <S.Container>
      <Banner appearance={appearance}>{children}</Banner>
    </S.Container>
  )
}
